import { createDynamicFieldsContext } from "$routes/_lib/dynamic-form-fields/dynamic-form-fields-context";
import { Typography } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import type { Property } from "../property-type";

type DefaultDynamicResultComponentProps = {
  property: Property;
};

export const DefaultDynamicResultComponent = ({
  property,
}: DefaultDynamicResultComponentProps): React.ReactElement => (
  <Typography variant="body1">{property.value}</Typography>
);

export interface DynamicResultProps {
  property: Property;
  print?: boolean;
}

export const DynamicResultFieldsContext =
  createDynamicFieldsContext<DynamicResultProps>();

const DynamicResult = (props: DynamicResultProps): React.ReactElement => {
  const { property } = props;
  const { meta, value } = property;
  const type = property.type as string;
  const { fieldMap } = React.useContext(DynamicResultFieldsContext);

  if (meta?.component) {
    const Component = fieldMap[meta.component as string];

    if (!Component) {
      console.warn(
        `DynamicResult could not render ${meta.component} as it does not exist in the fieldMap.`,
      );
      return null;
    }

    return <Component property={property} />;
  }

  const Component = fieldMap[type];
  if (Component) {
    return <Component property={property} />;
  }

  if (property.enum) {
    const indexOf = property.enum.indexOf(property.value);
    const display = meta.enumTitles[indexOf];
    return <Typography variant="body1">{display}</Typography>;
  }

  if (!value) {
    return (
      <Typography variant="body1">
        <FormattedMessage id="investigation.result.empty" defaultMessage="-" />
      </Typography>
    );
  }

  return <DefaultDynamicResultComponent property={property} />;
};

export default DynamicResult;
